import type {
  ReferralActivityItem,
  ReferralEarningsEntry,
  ReferralHistoryItem,
  ReferralHistoryStats,
  ReferralListItem,
  ReferralSummary,
} from '@/types/referral';

export const referralFixture = {
  summary: {
    referralCode: 'ADA2024',
    referralLink: 'https://sellyt.shop/sign-up?ref=ADA2024',
    totalEarnings: 12500,
    availableBalance: 7200,
    thisMonthEarnings: 1500,
    activeReferralsCount: 2,
    unreadActivityCount: 3,
    canWithdraw: true,
    activeReferralLimit: 50,
  } satisfies ReferralSummary,
  referrals: [
    {
      id: 'ref-1',
      name: 'Bimpe A.',
      status: 'ACTIVE',
      signupDate: '2026-02-12T10:00:00.000Z',
      monthIndicator: 'Month 3 of 6',
      thisMonthEarnings: 1500,
      totalEarnings: 4500,
      upgradeBonusClaimed: false,
    },
    {
      id: 'ref-2',
      name: 'Ngozi O.',
      status: 'QUALIFIED',
      signupDate: '2026-04-02T10:00:00.000Z',
      monthIndicator: 'Qualified',
      thisMonthEarnings: 500,
      totalEarnings: 500,
      upgradeBonusClaimed: false,
    },
    {
      id: 'ref-3',
      name: 'Aisha K.',
      status: 'EXPIRED',
      signupDate: '2026-01-05T10:00:00.000Z',
      monthIndicator: 'Expired',
      thisMonthEarnings: 0,
      totalEarnings: 0,
      upgradeBonusClaimed: false,
    },
  ] satisfies ReferralListItem[],
  activity: [
    {
      id: 'act-1',
      referralId: 'ref-2',
      referralName: 'Ngozi O.',
      eventType: 'FIRST_SALE',
      message: 'Ngozi made her first sale! You earned ₦500',
      amount: 500,
      createdAt: '2026-05-10T09:15:00.000Z',
      isRead: false,
    },
    {
      id: 'act-2',
      referralId: 'ref-1',
      referralName: 'Bimpe A.',
      eventType: 'MONTHLY_EARNING',
      message: '₦1,500 earned from Bimpe’s April sales',
      amount: 1500,
      createdAt: '2026-05-01T08:00:00.000Z',
      isRead: false,
    },
    {
      id: 'act-3',
      referralId: 'ref-2',
      referralName: 'Ngozi O.',
      eventType: 'CHANNEL_CONNECTED',
      message: 'Ngozi connected her WhatsApp',
      createdAt: '2026-04-04T12:30:00.000Z',
      isRead: true,
    },
    {
      id: 'act-4',
      referralId: 'ref-2',
      referralName: 'Ngozi O.',
      eventType: 'SIGNUP',
      message: 'Ngozi just joined using your link',
      createdAt: '2026-04-02T10:00:00.000Z',
      isRead: true,
    },
  ] satisfies ReferralActivityItem[],
  historyStats: {
    totalReferrals: 3,
    totalQualified: 2,
    totalEarnings: 12500,
    bestReferralName: 'Bimpe A.',
    bestReferralEarnings: 4500,
    activeSlotsRemaining: 48,
  } satisfies ReferralHistoryStats,
  history: {
    active: [
      {
        id: 'ref-1',
        name: 'Bimpe A.',
        status: 'ACTIVE',
        totalEarnings: 4500,
        monthProgress: 'Month 3 of 6',
        thisMonthEarnings: 1500,
      },
    ],
    completed: [],
    expired: [
      {
        id: 'ref-3',
        name: 'Aisha K.',
        status: 'EXPIRED',
        totalEarnings: 0,
      },
    ],
  } satisfies Record<'active' | 'completed' | 'expired', ReferralHistoryItem[]>,
  earnings: [
    {
      id: 'earn-1',
      createdAt: '2026-05-10T09:15:00.000Z',
      description: '₦500 earned. Ngozi qualified',
      amount: 500,
      balanceAfter: 7200,
      type: 'ACTIVATION',
    },
    {
      id: 'earn-2',
      createdAt: '2026-05-01T08:00:00.000Z',
      description: '₦1,500 earned. Bimpe’s April sales',
      amount: 1500,
      balanceAfter: 6700,
      type: 'ONGOING',
    },
    {
      id: 'earn-3',
      createdAt: '2026-04-15T11:00:00.000Z',
      description: '₦5,000 withdrawn to GTBank ****1234',
      amount: -5000,
      balanceAfter: 5200,
      type: 'WITHDRAWAL',
    },
  ] satisfies ReferralEarningsEntry[],
};
